import { Heading } from '@app/shared/ui/atoms/Common';
import { taroCardsImage } from '@app/assets';

interface TaroCardsTitleProps {
  title: string;
}

export function TaroCardsTitle({ title }: TaroCardsTitleProps) {
  return (
    <div className="flex items-center gap-4">
      <div className="flex size-12 items-center justify-center rounded-full bg-blue-light">
        <img src={taroCardsImage} alt="taro cards" className="h-[30px]" />
      </div>
      <Heading level={4}>{title}</Heading>
    </div>
  );
}
